import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { isSamplesDrawerShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { changeSizeIndex, placeSampleInCart } from '../../../redux/product/product.actions';
import { clickBuyPrinted } from '../../../redux/cart/cart.actions';
import { blankSamplePriceSelector, printedSamplePriceSelector, isPrintedSampleAvailableSelector, isBlankSampleAvailableSelector, embellishmentErrorSelector, sizeSelector, isApparelSelector, outOfStockSizesForSampleSelector, isAnyLogoUploadedSelector } from '../../../redux/product/product.selectors';
import { SamplesDrawerComponent } from './samples-drawer';
const mapStateToProps = createStructuredSelector({
  blankSamplePrice: blankSamplePriceSelector,
  printedSamplePrice: printedSamplePriceSelector,
  isDesignUploaded: isAnyLogoUploadedSelector,
  open: isSamplesDrawerShownSelector,
  isPrintedSampleAvailable: isPrintedSampleAvailableSelector,
  isBlankSampleAvailable: isBlankSampleAvailableSelector,
  embellishmentError: embellishmentErrorSelector,
  size: sizeSelector,
  isApparel: isApparelSelector,
  outOfStockSizes: outOfStockSizesForSampleSelector
});
const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch(hidePopup());
  },
  onClickBuyPrinted: () => {
    dispatch(clickBuyPrinted());
  },
  onBuyPrinted: () => {
    dispatch(hidePopup());
    dispatch(placeSampleInCart({
      isPrintedSample: true
    }));
  },
  onBuyBlank: () => {
    dispatch(hidePopup());
    dispatch(placeSampleInCart());
  },
  onChangeSize: sizeIndex => {
    dispatch(changeSizeIndex(sizeIndex));
  }
});
export const SamplesDrawer = connect(mapStateToProps, mapDispatchToProps)(SamplesDrawerComponent);